export const blockIconsUiactionsArrowRightAltNew = (
	<span className='material-symbols-outlined'>arrow_right_alt</span>
);
